module.exports = __webpack_public_path__ + "img/مستطیل1.96496cad.png";